import {
  leetcode,
  gfg,
  codechef,
  codeforces,
  hackerrank,
} from "../assets/Img/images";

export const achievements = [
  {
    key: 1,
    img: leetcode,
    platform: "leetcode",
    id: "hharshit8118",
    link: "https://leetcode.com/hharshit8118/",
    problem_solved: "650+",
    max_rating: "1794",
    other: [
      "4 monthly badges",
      "6 study plan badges",
      "100 days consistency badge",
    ],
  },
  {
    key: 2,
    img: gfg,
    platform: "GFG",
    id: "hharshit8118",
    link: "https://auth.geeksforgeeks.org/user/hharshit8118",
    problem_solved: "500+",
    max_rating: "-",
    other: [
      "Published Data Pipelining article",
      "Improved 3 articles",
      "1500+ coding score",
    ],
  },
  {
    key: 3,
    img: hackerrank,
    platform: "hackerrank",
    id: "hharshit8118",
    link: "https://www.hackerrank.com/hharshit8118",
    problem_solved: "200+",
    max_rating: "-",
    other: [
      `Python Certified`,
      `5 * in Problem Solving`,
      `5 * in C++`,
      `5 * in C`,
      `4 * in Java`,
    ],
  },
  {
    key: 4,
    img: codechef,
    platform: "codechef",
    id: "harsh_it_8118",
    link: "https://www.codechef.com/users/harsh_it_8118",
    problem_solved: "200+",
    max_rating: "1669",
    other: [
      `3 * at codechef`,
      "Rank 135th in Long challenge",
      "Rank 230th in starters 80",
    ],
  },
  {
    key: 5,
    img: codeforces,
    platform: "codeforces",
    id: "harsh_it_8118",
    link: "https://codeforces.com/profile/harsh_it_8118",
    problem_solved: "150+",
    max_rating: "1207",
    other: ["Rank 1436 in Round-871", "Pupil at Codeforces"],
  },
  // {
  //     key: 6,
  //     img: atcoder,
  //     platform: 'atcoder',
  //     id: 'hharshit8118',
  //     link: 'https://atcoder.jp/users/hharshit8118',
  //     problem_solved: '15+',
  //     max_rating: '126',
  //     other: [],
  // },
];

export const semesterAchievements = {
  sem1: "8.80",
  sem2: "8.90",
  sem3: "9.14",
  sem4: "8.57",
  sem5: "8.45",
  sem6: "8.33",
  sem7: "",
  sem8: "",
};
